<div class="form-header">
  Match the company names with the existing companies within Manage. If the company is not found
within the dropdown on the right, then the company must be created within Manage before it can be 
displayed here. All companies below must be matched before Manage Integration can be enabled.
</div>

<cw-ci-data-table #userDataTable
  tileTitle=""
  defaultSortField="account_name"
  hidePageSize="true"
  hideRefreshButton="true"
  hideWrapper="true"
  pageSize="8"
  skipInitialLoad="true"
  (loadItemsHandler)="loadSubaccounts($event)"
  [showLoadingAlert]="false"
  [items]="subAccountList"
  class="subaccount-multiline"
  [emptyListOverlay]="emptyListOverlay">

  <ng-template #emptyListOverlay>
    <div *ngIf="hasManageIntegration" style="display:flex; flex-direction:column; align-items: center; justify-content: center;">
      <img style="padding-bottom:20px;" src="assets/icons/large/large_icon_company.svg">
      <h2>Save and Enable your Manage integration</h2>
      <div style="max-width:500px; padding-bottom:20px; text-align: center;">There are no companies for you to match. You can save and enable your Manage integration.</div>
    </div>
    <div *ngIf="!hasManageIntegration" style="display:flex; flex-direction:column; align-items: center; justify-content: center;">
      <h2>Your Manage integration is not setup</h2>
      <div style="max-width:500px; padding-bottom:20px; text-align: center;">Please update your Manage integration first.</div>
    </div>
  </ng-template>

  <cw-ci-table-column columnName="name" columnTitle="Identify Company" sortField="account_name"></cw-ci-table-column>
  
  <cw-ci-table-column columnName="actions" columnTitle="Manage Company" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <div class="action-template">
      <mat-form-field [class.mat-form-field-invalid]="checkIfError(dropDown)">
        <input type="text" matInput placeholder="Company Name" [formControl]="dropDown.searchControl" [matAutocomplete]="dropDown.auto">
        <cw-manage-company-dropdown #dropDown
          (eventHandler)="handleEvent(element, $event)"
          [partnerAccount]="account"
          [value]="element.partner ? {value:element.partner.companyRecId, description:element.partner['manageCompanyName']} : null"
          ></cw-manage-company-dropdown>
        <mat-hint *ngIf="checkIfError(dropDown)" style="color: #ff5252;">Duplicate mapping</mat-hint>
      </mat-form-field>
    </div>
  </ng-template>
</cw-ci-data-table>
